const getProjectsRoute = (): string => "/projects";
const getLandingRoute = (): string => "/";
const getLoginRoute = (): string => "/login";
const getHomeRoute = (): string => "/home";

const getProjectDetailsRoute = (id?: number): string => {
  if (id !== undefined) {
    sessionStorage.setItem("project-id-form", id.toString());
  }
  return "/projects/form";
};

export const routesManager = {
  getProjectsRoute,
  getLandingRoute,
  getLoginRoute,
  getHomeRoute,
  getProjectDetailsRoute,
};
